// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Exte... Remove this comment to see the full error message
import SidekickExtensionInstallHelpers from 'ExtensionInstallHelpers/SidekickExtensionInstallHelpers';
const CHROME_EXTENSION_INSTALLED = 'chrome-extension-installed';
export function get() {
  return {
    [CHROME_EXTENSION_INSTALLED]: SidekickExtensionInstallHelpers.hasExtension()
  };
}